import { Component } from '@angular/core';
import { Usuario } from '../models/usuario';
import { FDLMService } from '../services/FDLM.Service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-nav-menu',
  templateUrl: './nav-menu.component.html',
  styleUrls: ['./nav-menu.component.css']
})
export class NavMenuComponent {
  isExpanded = false;
  usuario: Usuario;

  constructor(private fdlmService: FDLMService,
    private router: Router) {
    this.fdlmService.usuario.subscribe(res => {
      this.usuario = res;
      console.log('Cambio el objeto menu:' + res);
    });
  }

  logout() {
    this.fdlmService.logout();
    this.router.navigate(['/login']);
  }

  collapse() {
    this.isExpanded = false;
  }

  toggle() {
    this.isExpanded = !this.isExpanded;
  }
}
